import { onMounted, onUnmounted } from 'vue';

export default function () {
  const appHeight = () => {
    document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
  };

  onMounted(() => {
    appHeight();
    window.addEventListener('resize', appHeight);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', appHeight);
  });
}
